<img priority fill cypressTag="General.Image" [ngSrc]="prefixedSrc" [alt]="alt" />
